import { responsesApi } from '@/services/api';
import { useMutation } from '@tanstack/react-query';

export const useDownloadFormResponseReport = () => {
  return useMutation({
    mutationFn: async (flowId: string) => {
      return responsesApi.export<Blob>(flowId, 'csv');
    },
    onSuccess: (blob, flowId) => {
      // Trigger browser download
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `flow-${flowId}-responses.csv`;
      a.click();
      URL.revokeObjectURL(url);
    },
    onError: (error) => {
      console.error('Failed to download form responses', error);
    },
  });
};
